import { createReducer, on } from "@ngrx/store";
import { EmailNotificationSetting } from "src/app/model/notification/EmailNotificationSetting";
import * as EmailNotificationSettingsActions from "./email-notification-settings.actions";

export interface EmailNotificationSettingsState {
    settings: EmailNotificationSetting[];
    loading: boolean;
    error: string | null;
    updatingEventCode: string | null;
}

const initialEmailNotificationSettingsState: EmailNotificationSettingsState = {
    settings: [],
    loading: false,
    error: null,
    updatingEventCode: null,
};

export const emailNotificationSettingsReducer = createReducer(
    initialEmailNotificationSettingsState,

    on(EmailNotificationSettingsActions.loadSettings, (state) => ({
        ...state,
        loading: true,
        error: null,
    })),

    on(
        EmailNotificationSettingsActions.loadSettingsSuccess,
        (state, { settings }) => ({
            ...state,
            settings,
            loading: false,
            error: null,
        }),
    ),

    on(
        EmailNotificationSettingsActions.loadSettingsFailure,
        (state, { error }) => ({
            ...state,
            loading: false,
            error,
        }),
    ),

    on(EmailNotificationSettingsActions.updateSetting, (state, { eventCode }) => ({
        ...state,
        updatingEventCode: eventCode,
        error: null,
    })),

    on(
        EmailNotificationSettingsActions.updateSettingSuccess,
        (state, { setting }) => ({
            ...state,
            settings: state.settings.map((currentSetting) =>
                currentSetting.eventCode === setting.eventCode
                    ? setting
                    : currentSetting,
            ),
            updatingEventCode: null,
            error: null,
        }),
    ),

    on(
        EmailNotificationSettingsActions.updateSettingFailure,
        (state, { eventCode, error }) => ({
            ...state,
            updatingEventCode:
                state.updatingEventCode === eventCode
                    ? null
                    : state.updatingEventCode,
            error,
        }),
    ),
);
